/* eslint-disable react/no-danger */
/* eslint-disable no-console */
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Col, Card, CardBody, CardTitle, Row } from 'reactstrap';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import styles from './airportinfo.module.scss';
import Clickable from '../../../../components/clickable/Clickable';

const AirportInformation = ({ height, data, fullScreenMode, handelFullScreen }) => (
  <Fragment>
    <Col lg={12} className={styles.cardHeight}>
      <Card
        className={height ? styles.airportInfoCard2 : styles.airportInfoCard}
        style={{ height: fullScreenMode ? '100vh' : '', width: fullScreenMode ? '100vw' : '' }}
      >
        <CardTitle className={styles.airfieldscardtitle}>
          <Col lg={12}>
            <Row className={styles.titleRow}>
              <Col className={styles.titleCol1}>
                <FormattedMessage
                  id="airfields.airport.information"
                  defaultMessage="Airport Information"
                />
              </Col>
              <Col className={styles.titleCol2}>
                {!fullScreenMode ? (
                  <Clickable onClick={() => { handelFullScreen(true, 1); }}>
                    <p style={{ fontSize: '16px', cursor: 'pointer', margin: 0, fontWeight: 'bold' }}>
                      <FullscreenIcon />
                    </p>
                  </Clickable>
                ) : (
                  <Clickable onClick={() => { handelFullScreen(false, 1); }}>
                    <p style={{ fontSize: '16px', cursor: 'pointer', margin: 0, fontWeight: 'bold' }}>
                      X
                    </p>
                  </Clickable>
                )}
              </Col>
            </Row>
          </Col>
        </CardTitle>
        <CardBody>
          {data && (
            <Col lg={12} className={styles.airportInfoCardDetail}>
              <div dangerouslySetInnerHTML={{ __html: data }} />
            </Col>
          )}
        </CardBody>
      </Card>
    </Col>
  </Fragment>
);

export default AirportInformation;
